import { render, staticRenderFns } from "./DetailPriceCard.vue?vue&type=template&id=6b6212a5&scoped=true&"
import script from "./DetailPriceCard.vue?vue&type=script&lang=ts&"
export * from "./DetailPriceCard.vue?vue&type=script&lang=ts&"
import style0 from "./DetailPriceCard.vue?vue&type=style&index=0&id=6b6212a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6212a5",
  null
  
)

export default component.exports